export const FEATURES_STATUSES = {
  MAPPING_PARTICIPANTS_TO_CONTACTS: 'MAPPING_PARTICIPANTS_TO_CONTACTS',
  MAKING_CALL_NOTES: 'MAKING_CALL_NOTES',
  ASSOCIATIONS_CONTACTS_WITH_CALL: 'ASSOCIATIONS_CONTACTS_WITH_CALL',
  ASSOCIATIONS_COMPANIES_WITH_CALL: 'ASSOCIATIONS_COMPANIES_WITH_CALL',
  ASSOCIATIONS_DEALS_WITH_CALL: 'ASSOCIATIONS_DEALS_WITH_CALL',
  ASSOCIATIONS_TICKETS_WITH_CALL: 'ASSOCIATIONS_TICKETS_WITH_CALL',
  ASSOCIATIONS_MEETINGS_WITH_CALL: 'ASSOCIATIONS_MEETINGS_WITH_CALL'
};
export const FEATURES = {
  MAPPING_PARTICIPANTS_TO_CONTACTS: {
    scopes: ['contacts-read', 'contacts-write'],
    scopeGroups: ['crm.objects.contacts.write', 'crm.objects.contacts.read']
  },
  MAKING_CALL_NOTES: {
    scopes: ['contacts-read', 'contacts-write'],
    scopeGroups: ['crm.objects.contacts.write', 'crm.objects.contacts.read']
  },
  ASSOCIATIONS_CONTACTS_WITH_CALL: {
    scopes: ['contacts-read', 'contacts-write'],
    scopeGroups: ['crm.objects.contacts.write', 'crm.objects.contacts.read']
  },
  ASSOCIATIONS_COMPANIES_WITH_CALL: {
    scopes: ['companies-write', 'companies-read'],
    scopeGroups: ['crm.objects.companies.write', 'crm.objects.companies.read']
  },
  ASSOCIATIONS_DEALS_WITH_CALL: {
    scopes: ['deals-read', 'deals-write'],
    scopeGroups: ['crm.objects.deals.write', 'crm.objects.deals.read']
  },
  ASSOCIATIONS_TICKETS_WITH_CALL: {
    scopes: ['tickets-write', 'tickets-read'],
    scopeGroups: ['tickets']
  },
  ASSOCIATIONS_MEETINGS_WITH_CALL: {
    scopes: ['contacts-read', 'contacts-write'],
    scopeGroups: ['crm.objects.contacts.write', 'crm.objects.contacts.read']
  },
  CREATING_DEALS_WITH_LINE_ITEMS: {
    scopes: ['deal-line-item-read'],
    scopeGroups: ['e-commerce']
  },
  PLAYBOOKS: {
    scopes: ['playbooks-read'],
    scopeGroups: ['integrations.zoom-app.playbooks.read']
  }
};
export const featureDisabledActionTypes = {
  redirect: 'redirect',
  reconnect: 'reconnect'
};